import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CinemaResponse, CinemasResponse } from './models';
import { axiosInstance, createQuery } from '../../libs';
import { long_term_cashing } from '@/constants/cashing';

const url = 'cinemas';

export const getCinemaList = (
  params: {
    cityId: number;
  },
  config: AxiosRequestConfig = {}
): Promise<CinemasResponse> => {
  return axiosInstance
    .get(`${url}`, { params, ...config })
    .then((res: AxiosResponse<CinemasResponse>) => {
      return res?.data;
    });
};

export const useGetCinemaList = createQuery<CinemasResponse, unknown, string>(
  {
    url: `${url}`,
    method: 'get',
  },
  {
    staleTime: long_term_cashing,
    keepPreviousData: false,
  }
);
export const useGetCinemaDetails = createQuery<
  CinemaResponse,
  unknown,
  string,
  {
    cityId: number;
  }
>({
  method: 'get',

  url: `${url}/unique-name/:slug`,
});

export const useGetCinemas = createQuery<CinemasResponse, unknown>(
  {
    method: 'get',
    url: `${url}`,
  },
  {
    staleTime: long_term_cashing,
    keepPreviousData: false,
  }
);

export const useGetCinema = createQuery<CinemaResponse, unknown>({
  method: 'get',
  url: `${url}/unique-name/:slug`,
});
